import { peekPostLoginRedirect } from "./postLoginRedirect";

const PROMOTION_INVITE_RESPONSE_PATH =
  /^\/quest\/promotions\/invite\/[^/?#]+\/?$/;

const TAKE_ACTION_AUTH_PATHS = new Set([
  "/login",
  "/auth",
  "/forgot-password",
  "/send-mail",
]);

const pathnameOnly = (path = "") =>
  String(path).split("?")[0].split("#")[0];

export const isPromotionInviteResponsePath = (path = "") =>
  PROMOTION_INVITE_RESPONSE_PATH.test(pathnameOnly(path));

export const isTakeActionAuthPath = (path = "") => {
  const pathname = pathnameOnly(path);
  if (TAKE_ACTION_AUTH_PATHS.has(pathname)) return true;
  return pathname.startsWith("/reset-password/");
};

export const isMobileTakeActionFlow = (pathname = "") => {
  if (isPromotionInviteResponsePath(pathname)) return true;
  return (
    isPromotionInviteResponsePath(peekPostLoginRedirect()) &&
    isTakeActionAuthPath(pathname)
  );
};
